import { Link } from "@mui/material";
import img from '../../Assets/outlink.svg';

const CustomLink = (props) => {

    return (
        <Link color='#246898' underline="none" fontWeight='600' className='link' target='_blank' href={props.href}>
            {props.text}
            <img style={{ maxWidth: '11px', marginLeft: '3px' }} src={img} />
        </Link>
    );

}

export default CustomLink;